
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/about",
      function () {
        return require("private-next-pages/en/about/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/about"])
      });
    }
  